import { RatingSelect } from '../../common/RatingSelect'
import { NpsStep } from './NPSStepBasePage'
import { FieldIds, NPSStepId, NPSStepProps, SCORE_HIGH, SCORE_LOW, StepIds } from './types'
import { NPSRecordState } from './NPSViewModel'
import { NPSWorkflowStep } from './useNPSFormWorkflowCoordinator'
import { validateScore } from './validation'

export const SCORE_STEP = {
    id: StepIds.SCORE,
    validate: ({ getFieldValue }: NPSRecordState) => {
        return validateScore(getFieldValue(FieldIds.SCORE))
    },
} as const satisfies NPSWorkflowStep<NPSStepId>

export function NPSStepScorePage(props: NPSStepProps) {
    const {
        recordForm: { getField },
    } = props

    return (
        <NpsStep
            {...props}
            title={getField(FieldIds.SCORE)!.label!}
            fieldGroups={[
                [
                    {
                        id: FieldIds.SCORE,
                        icon: 'thumbsUp.large',
                        label: 'Likelihood to recommend',
                        render: (value: unknown, onChange: (value: unknown) => void) => (
                            <RatingSelect
                                value={typeof value === 'number' ? value : undefined}
                                onChange={onChange}
                                lower={SCORE_LOW}
                                upper={SCORE_HIGH}
                                lowSentiment="Not at all likely"
                                highSentiment="Extremely likely"
                            />
                        ),
                    },
                ],
            ]}
        />
    )
}
